var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-permissions"},[_vm._m(0),_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.$t('general.noPermissions'))+" ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"fas fa-lock"})])
}]

export { render, staticRenderFns }